import { ObservableFromFetch } from "../ObservableFromFetch"
import Role from "./Model/Role"

export default function UserRolesGetObservable(link?: string) {
  const requestBody: string = JSON.stringify(link ? { Link: link } : {})
  return ObservableFromFetch<Role[]>("FFOrderRolePermission/GetUserRoles", requestBody)
}

export function GetRolesToInvite() {
  return ObservableFromFetch<Role[]>("FFOrderUserInvitation/GetRolesToInvite")
}

export function GetRoleDroplist(roleID: number) {
  const requestBody: string = new URLSearchParams({
    roleID: roleID.toString()
  }).toString()

  return ObservableFromFetch<Role[]>("FFOrderUserInvitation/GetRoleDroplistByID?" + requestBody)
}

export function GetRoles(roleID: number, link?: string) {
  const requestParams = link ? { roleID: roleID.toString(), Link: link } : { roleID: roleID.toString() }
  const requestBody: string = JSON.stringify(requestParams).toString()

  return ObservableFromFetch<Role[]>("FFOrderUserInvitation/GetRole", requestBody)
}

export function GetRolesPerLink(link: string) {
  const requestBody: string = JSON.stringify({ Link: link }).toString()
  return ObservableFromFetch<Role[]>("FFOrderUserInvitation/GetRole", requestBody)
}
